module.exports = __webpack_public_path__ + "img/luyuanShareBg.928be3c2.png";